import { type IFrameInfo, StateEnum, WeaponEnum } from "../defines";
import { Entity } from "../entity";
import { CharacterState_Base } from "./CharacterState_Base";

export class CharacterState_Injured extends CharacterState_Base {
  constructor(state: StateEnum = StateEnum.Injured) {
    super(state);
  }
  override enter(e: Entity, prev_frame: IFrameInfo): void {
    super.enter?.(e, prev_frame);
    const holding = e.holding
    if (holding?.base_type === WeaponEnum.Heavy) {
      e.drop_holding()
      holding.team = e.team;
    }
  }
}
